import React from "react"

import Layout from "../components/common/layout/layout"
import SEO from "../components/common/layout/seo"
import Navigation from "../components/common/navigation/navigation"

import Header from "../components/sections/header"
import HowItWorks from "../components/sections/howitworks"
import Community from "../components/sections/community"
import Memories from "../components/sections/memories"
import Bitcoin from "../components/sections/bitcoin"
import Sunrise from "../components/sections/sunrise"
import SocialProof from "../components/sections/socialproof"
import FAQ from "../components/sections/faq"
import GetStarted from "../components/sections/getstarted"
import Footer from "../components/sections/footer"

const IndexPage = () => (
  <Layout>
    <SEO title="Make today Day One ☀️" />
    <Navigation />
    <Header />
    <HowItWorks />
    <Community />
    <Memories />
    <Bitcoin />
    <Sunrise />
    <SocialProof />
    <FAQ />
    <GetStarted />
    <Footer />
  </Layout>
)

export default IndexPage
